import React from 'react'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as UI from 'ui'
import TranslatedTitle from 'widgets/TranslatedTitle'
import PeriodFilterSyncedWithPage from 'support/filters/PeriodFilterSyncedWithPage'
import { Model } from '@morningtrain/react-resources'
import { SelectedDepartmentFilter } from 'support/filters'
import WageRatioTable from './partials/WageRatioTable'
import WageRatioChartLoader from 'widgets/charts/loaders/WageRatioChartLoader'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import CookieFilter from "support/filters/CookieFilter";

export default function WageRatio () {
  return (
    <AdminPageWithSmartview slideInSmartview>
      <Translator namespace='economy.pages.wage_ratio'>
        <UI.PageHeader title={<TranslatedTitle />}>
          <PeriodFilterSyncedWithPage selectors={['this_week', 'this_month', 'this_year']} />
        </UI.PageHeader>

        <UI.CardGroup>

          <Model resourceName='dashboard' operationName='wage_ratio'>
            <SelectedDepartmentFilter />
            <CookieFilter name='period' cookieKey='page.filters.period' />

            <div className='space-x-4 flex'>
              <UI.Card className='w-full'>
                <UI.CardHeader>
                  <UI.SecondaryHeading width='w-auto'>
                    <Translation name='chart_title' />
                  </UI.SecondaryHeading>
                  <UI.Legend>
                    <UI.LegendItem colorHex='#e15b5b'>
                      <Translation name='legends.budgeted' />
                    </UI.LegendItem>
                    <UI.LegendItem colorHex='#69b3e4'>
                      <Translation name='legends.realized' />
                    </UI.LegendItem>
                  </UI.Legend>
                </UI.CardHeader>
                <div className='w-full h-96'>
                  <WageRatioChartLoader />
                </div>
              </UI.Card>
            </div>

            <WageRatioTable />

          </Model>
        </UI.CardGroup>
      </Translator>
    </AdminPageWithSmartview>
  )
}
